module.exports = __webpack_public_path__ + "img/羊角禄段古荔园.fbd980f2.png";